const BETA_BASE = "/api/v1/beta";

export interface BetaRequestPayload {
  name: string;
  company: string;
  email: string;
  need: string;
  /** Which form sent this — only labels the notification email. */
  source?: "beta" | "reports";
}

export async function submitBetaRequest(payload: BetaRequestPayload): Promise<void> {
  const res = await fetch(`${BETA_BASE}/request`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let detail = "Failed to send request.";
    try {
      const data = await res.json();
      if (typeof data?.detail === "string") detail = data.detail;
    } catch {}
    throw new Error(detail);
  }
}
